import { normalize } from 'normalizr';
import updateEntities from 'common/actions/updateEntities';
import fetchService from 'common/actions/fetchService';
import busProviderId from 'modules/bus/shared/selectors/userConfig/busProviderId';
import TemporarySystemDisruptionException from 'common/exceptions/TemporarySystemDisruptionException';
import i18n from 'common/locale/i18n';
import { BOOKING_SEARCH_RESULT_STATUS_EMPTY_STATE } from 'modules/bus/booking/search-result/constants/busBookingFetchSearchResultContants';
import createBusTransactionListInventorySchema from '../schemas/busTransactionListInventorySchema';

export const BUS_FETCH_TRANSACTION_LIST = 'BUS_FETCH_TRANSACTION_LIST';

export const BUS_TRANSACTION_LIST_LIMIT = 10;

export default ({ page, filter, shouldAppendToCurrentState }) => async (
  dispatch,
  getState
) => {
  const limit = BUS_TRANSACTION_LIST_LIMIT;
  const spec = {
    limit,
    page,
    filter: {
      ...filter,
      isReservationList: Boolean(filter.isReservationList),
    },
    providerId: busProviderId(getState()),
  };

  return dispatch(
    fetchService(({ pssService }) =>
      pssService.fetch(
        'POST',
        '/api/v2/busextranetagent/search/transactionList',
        spec
      )
    )
  )
    .catch(() => {
      throw new TemporarySystemDisruptionException(
        i18n.getText('error_temporary_disruption_message'),
        {
          title: i18n.getText('error_temporary_disruption_title'),
        }
      );
    })
    .then(({ result }) => {
      const { data } = result;
      const { entities, result: idList } = normalize(
        data.busExtranetTransactionList,
        [createBusTransactionListInventorySchema(filter.isReservationList)]
      );

      dispatch(updateEntities(entities));

      const prevInventories = getState().bus.transactionList.inventories;

      dispatch({
        type: BUS_FETCH_TRANSACTION_LIST,
        payload: {
          ...data,
          isReservationList: Boolean(filter.isReservationList),
          agentId: filter.agentId,
          startDate: filter.startDate,
          endDate: filter.endDate,
          inventories: shouldAppendToCurrentState
            ? [...prevInventories, ...idList]
            : idList,
          // delete raw data
          busExtranetTransactionList: undefined,
          disableFetch: data.busExtranetTransactionList.length < 1,
        },
      });

      if (prevInventories.length <= 0 && idList.length <= 0) {
        return { error: BOOKING_SEARCH_RESULT_STATUS_EMPTY_STATE };
      }

      return {};
    });
};
